import { FiscalAccountType, HoldingMethod } from '@blockpulse3/graphql/hooks';

/**
 *  checkFiscalAccountHoldingMethod.
 *  Check if a fiscal account is in the list of allowed holding methods
 *
 * @param {HoldingMethod[]} allowedHoldingMethods
 * @returns {boolean}
 */
export const checkFiscalAccountHoldingMethod = (
  allowedHoldingMethods: HoldingMethod[] | null | undefined,
): boolean => {
  if (!allowedHoldingMethods) return false;

  const fiscalAccountType = Object.keys(FiscalAccountType);
  const isFiscalAccountAllowed = allowedHoldingMethods.some((value) =>
    fiscalAccountType.includes(HoldingMethod[value]),
  );

  return isFiscalAccountAllowed;
};
